import _slicedToArray from "/codebuild/output/src1787262798/src/tpp-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import * as e from "react";
import r, { useRef as a, useState as t, useEffect as o } from "react";
import n, { oneOfType as l, shape as i, number as c, string as s, array as d, arrayOf as u, objectOf as p } from "prop-types";
import h from "@material-ui/core/TextField";
import g from "@material-ui/core/Popover";
import { makeStyles as m, createGenerateClassName as b, StylesProvider as v } from "@material-ui/core/styles";
import f from "@material-ui/core/Button";
import x from "@material-ui/core/Tooltip";
import w from "@material-ui/core/Box";
import y from "@material-ui/core/Divider";
import k from "@material-ui/core/FormControl";
import C from "@material-ui/core/FormHelperText";
import E from "@material-ui/core/InputLabel";
import N from "@material-ui/core/Input";
import O from "@material-ui/core/InputAdornment";
import R from "@material-ui/core/Slider";

function S(e, r, a) {
  return r in e ? Object.defineProperty(e, r, {
    value: a,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = a, e;
}

function P() {
  return (P = Object.assign || function (e) {
    for (var r = 1; r < arguments.length; r++) {
      var a = arguments[r];

      for (var t in a) {
        Object.prototype.hasOwnProperty.call(a, t) && (e[t] = a[t]);
      }
    }

    return e;
  }).apply(this, arguments);
}

function W(e, r) {
  var a = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(e);
    r && (t = t.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), a.push.apply(a, t);
  }

  return a;
}

function M(e) {
  for (var r = 1; r < arguments.length; r++) {
    var a = null != arguments[r] ? arguments[r] : {};
    r % 2 ? W(Object(a), !0).forEach(function (r) {
      S(e, r, a[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : W(Object(a)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(a, r));
    });
  }

  return e;
}

function A(e, r) {
  if (null == e) return {};

  var a,
      t,
      o = function (e, r) {
    if (null == e) return {};
    var a,
        t,
        o = {},
        n = Object.keys(e);

    for (t = 0; t < n.length; t++) {
      a = n[t], r.indexOf(a) >= 0 || (o[a] = e[a]);
    }

    return o;
  }(e, r);

  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);

    for (t = 0; t < n.length; t++) {
      a = n[t], r.indexOf(a) >= 0 || Object.prototype.propertyIsEnumerable.call(e, a) && (o[a] = e[a]);
    }
  }

  return o;
}

var j,
    D,
    T = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgrey: 11119017,
  darkgreen: 25600,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  grey: 8421504,
  green: 32768,
  greenyellow: 11403055,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgrey: 13882323,
  lightgreen: 9498256,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
},
    L = function L(e, r) {
  var a = "00000000".concat((16777215 & e).toString(16).toUpperCase()).substr(-6);

  if (!Number.isNaN(r) && void 0 !== r) {
    var t = r.toString(16).toUpperCase();
    1 === t.length && (t = "0".concat(t)), a += t;
  }

  return a;
},
    G = function G(e) {
  return [(16711680 & e) >> 16, (65280 & e) >> 8, 255 & e];
},
    F = function F(e) {
  var r = e.map(function (e) {
    var r = e || 0;
    return r < 0 && (r = 0), r > 255 && (r = 255), r;
  });
  return r[3] << 24 | r[0] << 16 | r[1] << 8 | r[2];
},
    z = function z(e) {
  if (!e || e.length < 3 || e.length > 4) return {
    error: "not valid size"
  };
  var r = e.map(function (e, r) {
    return "string" == typeof e ? "%" !== e[e.length - 1] ? Math.round(Number(e) * (3 === r ? 255 : 1)) : Math.round(Number(e.substring(0, e.length - 1)) / 100 * 255) : Math.round(3 === r ? 255 * e : e);
  });
  return {
    format: "rgb",
    value: F(r),
    rgb: r,
    alpha: r[3]
  };
},
    q = function q(e) {
  var r,
      a = Number("0x".concat(e.substring(1)));
  if (!Number.isInteger(a) || Number.isNaN(a)) return {
    error: "Not an hex value"
  };
  var t = [];

  if (7 === e.length || 9 === e.length) {
    var o = 9 === e.length ? 8 : 0;
    t[0] = a >> 16 + o & 255, t[1] = a >> 8 + o & 255, t[2] = a >> o & 255, 9 === e.length && (r = 255 & a, t[3] = r, a = F(t));
  } else {
    if (4 !== e.length && 5 !== e.length) return {
      error: "Wrong format"
    };
    var n = 5 === e.length ? 4 : 0;
    t[0] = a >> 8 + n & 15, t[1] = a >> 4 + n & 15, t[2] = a >> n & 15, t[0] |= t[0] << 4, t[1] |= t[1] << 4, t[2] |= t[2] << 4, 5 === e.length && (r = 15 & a, r |= r << 4, t[3] = r), a = F(t);
  }

  return {
    format: "hex",
    value: a,
    rgb: t,
    alpha: r
  };
},
    I = function I(e) {
  var r = e;
  return "string" == typeof r && (r.indexOf("deg") > -1 ? r = r.substr(0, r.length - 3) : r.indexOf("rad") > -1 ? r = Math.round(r.substr(0, r.length - 3) * (180 / Math.PI)) : r.indexOf("turn") > -1 && (r = Math.round(360 * r.substr(0, r.length - 4))), r = parseFloat(r, 10)), Number.isNaN(r) && (r = 0), r >= 360 && (r %= 360), r < 0 && (r = 0), r;
},
    H = function H(e) {
  var r = e;
  return "string" == typeof r && (r = parseFloat(r.indexOf("%") > -1 ? r.substring(0, r.length - 1) : r, 10)), Number.isNaN(r) ? r = 0 : r > 100 ? r = 100 : r < 0 && (r = 0), r;
},
    B = function B(e) {
  if (!e || e.length < 3 || e.length > 4) return {
    error: "Not a valid size"
  };
  var r,
      a = e,
      t = I(a[0]),
      o = H(a[1]),
      n = H(a[2]);
  a[0] = t, a[1] = o, a[2] = n, n /= 100;
  var l = (o /= 100) * (1 - Math.abs(2 * n - 1)),
      i = l * (1 - Math.abs(t / 60 % 2 - 1)),
      c = n - l / 2;
  0 === o ? (r = [n, n, n], c = 0) : r = t >= 0 && t < 60 ? [l, i, 0] : t >= 60 && t < 120 ? [i, l, 0] : t >= 120 && t < 180 ? [0, l, i] : t >= 180 && t < 240 ? [0, i, l] : t >= 240 && t < 300 ? [i, 0, l] : [l, 0, i], r[0] = Math.round(255 * (r[0] + c)), r[1] = Math.round(255 * (r[1] + c)), r[2] = Math.round(255 * (r[2] + c));
  var s = a[3];
  return void 0 !== s && ("string" == typeof s && (s = s.indexOf("%") > -1 ? parseFloat(s.substring(0, s.length - 1), 10) / 100 : parseFloat(s, 10)), s = Math.floor(255 * s), r[3] = s), {
    format: "hsl",
    value: F(r),
    rgb: r,
    hsl: a,
    alpha: s
  };
},
    V = function V(e) {
  if (!e || e.length < 3 || e.length > 4) return {
    error: "Not a valid size"
  };
  var r,
      a = I(e[0]),
      t = H(e[1]),
      o = H(e[2]);
  if (o *= 2.55, 0 === t) r = [o = Math.round(o), o, o];else {
    a /= 360, t /= 100;
    var n = Math.floor(6 * a),
        l = 6 * a - n,
        i = Math.round(o * (1 - t)),
        c = Math.round(o * (1 - t * l)),
        s = Math.round(o * (1 - t * (1 - l)));
    o = Math.round(o), r = 0 === (n %= 6) ? [o, s, i] : 1 === n ? [c, o, i] : 2 === n ? [i, o, s] : 3 === n ? [i, c, o] : 4 === n ? [s, i, o] : [o, i, c];
  }
  var d = e[3];
  return void 0 !== d && ("string" == typeof d && (d = d.indexOf("%") > -1 ? parseFloat(d.substring(0, d.length - 1), 10) / 100 : parseFloat(d, 10)), d = Math.floor(255 * d), r[3] = d), {
    format: "hsl",
    value: F(r),
    rgb: r,
    hsv: e,
    alpha: d
  };
},
    X = function X(e) {
  var r = e[0] / 255,
      a = e[1] / 255,
      t = e[2] / 255,
      o = Math.min(r, a, t),
      n = Math.max(r, a, t);
  return {
    cmax: n,
    cmin: o,
    delta: n - o,
    r: r,
    g: a,
    b: t
  };
},
    Y = function Y(e) {
  var _X = X(e),
      r = _X.cmin,
      a = _X.cmax,
      t = _X.delta,
      o = _X.r,
      n = _X.g,
      l = _X.b,
      i = 0,
      c = 0,
      s = (r + a) / 2;

  0 !== t && (c = t / (1 - Math.abs(2 * s - 1)), c = Math.round(+(100 * c).toFixed(1)), i = a === o ? (n - l) / t % 6 : a === n ? (l - o) / t + 2 : (o - n) / t + 4, (i = Math.round(60 * i)) < 0 && (i += 360));
  var d = [i, c, s = Math.round(s + 100 * s)];
  return 4 === e.length && (d[3] = e[3] / 255), d;
},
    U = function U(e) {
  var _X2 = X(e),
      r = _X2.cmax,
      a = _X2.delta,
      t = _X2.r,
      o = _X2.g,
      n = _X2.b;

  if (0 === a) return [0, 0, Math.round(100 * r)];
  var l,
      i = r,
      c = a / r,
      s = (r - t) / a,
      d = (r - o) / a,
      u = (r - n) / a;
  return (l = (l = t === r ? u - d : o === r ? 2 + s - u : 4 + d - s) / 6 % 1) < 0 && (l += 1), [l = Math.round(360 * l), c = Math.round(100 * c), i = Math.round(100 * i)];
},
    K = function K(e) {
  var r = e.substring(e.indexOf("(") + 1, e.indexOf(")"));
  return r.indexOf(",") > -1 ? r.split(",") : r.indexOf(" ") > -1 ? r.split(" ").filter(function (e) {
    return e.length > 0 && "/" !== e;
  }) : void 0;
},
    J = ["plain", "hex", "rgb", "hsl", "hsv"],
    Q = [function (e) {
  return {
    format: "plain",
    value: T[e[0]]
  };
}, function (e) {
  return q(e[0]);
}, function (e) {
  return z(e);
}, function (e) {
  return B(e);
}, function (e) {
  return V(e);
}],
    Z = [function (e) {
  return {
    format: "plain",
    value: T[e]
  };
}, function (e) {
  return q(e);
}, function (e) {
  return z(K(e));
}, function (e) {
  return B(K(e));
}],
    $ = [function (e) {
  return void 0 !== T[e];
}, function (e) {
  return e.startsWith("#");
}, function (e) {
  return e.startsWith("rgb(") || e.startsWith("rgba(");
}, function (e) {
  return e.startsWith("hsl(") || e.startsWith("hsla(");
}],
    _ = function _(e, r) {
  var _z, _B, _V;

  var a,
      t,
      o,
      n,
      l,
      i,
      c,
      s = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
      d = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3],
      u = {
    raw: e
  },
      p = r || "unknown";
  if ("transparent" === e) u.name = e, p = "plain", t = 0;else if ("string" == typeof e) {
    var _Z$g;

    var h = e.trim().toLocaleLowerCase(),
        g = $.findIndex(function (e) {
      return e(h);
    });
    g > -1 && ((_Z$g = Z[g](h), a = _Z$g.value, p = _Z$g.format, o = _Z$g.rgb, n = _Z$g.hsl, t = _Z$g.alpha, i = _Z$g.error, _Z$g), "plain" === p && (u.name = e), p && (u.css = {
      backgroundColor: e
    }));
  } else if (Number.isInteger(e)) a = e, p = "number";else if (Array.isArray(e) && p) {
    var _Q$m;

    var m = J.findIndex(function (e) {
      return e === p;
    });
    m > -1 ? (_Q$m = Q[m](e), a = _Q$m.value, p = _Q$m.format, o = _Q$m.rgb, n = _Q$m.hsl, l = _Q$m.hsv, t = _Q$m.alpha, i = _Q$m.error, _Q$m) : i = "unkown format";
  } else e && "r" in e && "g" in e && "b" in e ? (o = [e.r, e.g, e.b], e.a && o.push(e.a), (_z = z(o), a = _z.value, p = _z.format, o = _z.rgb, t = _z.alpha, i = _z.error, _z)) : e && "h" in e && "s" in e && "l" in e ? (n = [e.h, e.s, e.l], e.a && n.push(e.a), (_B = B(n), a = _B.value, p = _B.format, o = _B.rgb, n = _B.hsl, t = _B.alpha, i = _B.error, _B)) : e && "h" in e && "s" in e && "v" in e && (l = [e.h, e.s, e.v], e.a && l.push(e.a), (_V = V(l), a = _V.value, p = _V.format, o = _V.rgb, l = _V.hsv, t = _V.alpha, i = _V.error, _V));
  void 0 === a && (a = 0, t = 0 === t ? t : void 0, u.css = {
    backgroundImage: "\n        linear-gradient(45deg, #ccc 25%, transparent 25%), \n        linear-gradient(135deg, #ccc 25%, transparent 25%),\n        linear-gradient(45deg, transparent 75%, #ccc 75%),\n        linear-gradient(135deg, transparent 75%, #ccc 75%)",
    backgroundSize: "8px 8px",
    backgroundPosition: "0 0, 4px 0, 4px -4px, 0px 4px",
    backgroundColor: "white"
  }, "transparent" !== e && (p = "unknown", u.name = "none")), i && (u.error = i), u.value = a, u.alpha = Number.isNaN(t) || void 0 === t ? 1 : t / 255, u.format = p, s || 1 === u.alpha ? 1 === u.alpha && -16777216 === u.value && (c = 255) : c = Math.floor(255 * u.alpha);
  var b = L(a, c);
  return u.hex = b, o = o || G(a), u.rgb = o, u.hsv = l || U(o), u.hsl = n || Y(o), u.css || (u.css = {
    backgroundColor: "#".concat(b)
  }), u.name || (u.name = d && Object.keys(T).find(function (e) {
    return T[e] === a;
  }) || "color-".concat(b)), u;
},
    ee = function ee(e, r, a) {
  var t;
  return "hex" === r && (t = "#".concat(L(e.value, a || 1 === e.alpha ? void 0 : Math.floor(255 * e.alpha)))), t;
},
    re = function re(e, r, a, t) {
  var o = arguments.length > 4 && void 0 !== arguments[4] && arguments[4],
      n = e,
      l = !1;
  return e && e.format && e.name ? n.error && a && (n.error = a(n.error)) : (n = e, a && "string" == typeof n && (j && t === D || (D = t, j = {}, Object.keys(T).forEach(function (e) {
    j[a(e)] = e;
  })), l = (n = j[n] || n) !== e), (n = _(n, null, r, !o)).name && a && (n.translated = a(n.name), l && n.translated && (n.name = n.translated), n.error && (n.error = a(n.error)))), n;
},
    ae = l([i({
  css: i({}),
  value: c,
  hex: s,
  raw: l([s, d, c, i]),
  name: s,
  alpha: c,
  rgb: u(c),
  hsv: u(c),
  hsl: u(c)
}), s, c]),
    te = p(s),
    oe = u(s),
    ne = {
  use: function use() {
    return {
      i18n: {
        language: "us"
      },
      t: function t(e) {
        return e;
      }
    };
  }
},
    le = function le(e) {
  return e && (ne.use = e), ne.use();
},
    ie = m({
  root: {
    backgroundImage: function backgroundImage(e) {
      return e.colorError || e.alpha < 1 ? "\n    linear-gradient(45deg, #ccc 25%, transparent 25%), \n    linear-gradient(135deg, #ccc 25%, transparent 25%),\n    linear-gradient(45deg, transparent 75%, #ccc 75%),\n    linear-gradient(135deg, transparent 75%, #ccc 75%)" : "none";
    },
    backgroundSize: "8px 8px",
    backgroundPosition: "0 0, 4px 0, 4px -4px, 0px 4px",
    backgroundColor: function backgroundColor(e) {
      return e.backgroundColor || "#fff";
    },
    boxShadow: "0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08)",
    borderColor: function borderColor(e) {
      return e.borderColor || "#767676";
    },
    borderStyle: "solid",
    borderWidth: function borderWidth(e) {
      return e.borderWidth || 0;
    },
    borderRadius: 4,
    padding: 0,
    width: function width(e) {
      return e.width;
    },
    minWidth: function minWidth(e) {
      return e.minWidth;
    },
    height: function height(e) {
      return e.height;
    },
    "& div": {
      content: '" "',
      background: function background(e) {
        return e.colorError ? "repeating-linear-gradient(\n      135deg,\n      transparent,\n      transparent ".concat(e.width / 2 + 2, "px,\n      #f44336 ").concat(e.width / 2 + 2, "px,\n      #f44336 ").concat(e.width / 2 + 4, "px\n    )") : "none";
      },
      backgroundColor: function backgroundColor(e) {
        return e.colorError ? "transparent" : e.backgroundColor || "#fff";
      },
      width: function width(e) {
        return e.width;
      },
      minWidth: function minWidth(e) {
        return e.minWidth;
      },
      height: function height(e) {
        return e.height;
      },
      border: function border(e) {
        return e.colorError ? "2px solid #f44336" : "".concat(e.borderWidth || 0, "px solid ").concat(e.borderColor || "#767676");
      },
      borderRadius: 4,
      padding: 0
    },
    "&:hover div": {
      backgroundColor: function backgroundColor(e) {
        return e.hoverColor;
      }
    },
    "&:active": {
      boxShadow: "none"
    },
    "&:focus": {
      boxShadow: "0 0 0 0.2rem rgba(0, 123, 255, 0.5)"
    }
  },
  tooltip: {
    width: "min-content"
  }
}),
    ce = function ce(e) {
  var a = e.color,
      t = e.size,
      o = e.borderWidth,
      n = e.borderColor,
      l = e.forwardRef,
      i = e.tooltip,
      c = e.disableAlpha,
      s = e.className,
      d = A(e, ["color", "size", "borderWidth", "borderColor", "forwardRef", "tooltip", "disableAlpha", "className"]),
      _le = le(),
      u = _le.t,
      p = _le.i18n,
      h = re(a, c, u, p.language),
      g = u(i),
      m = h.css,
      b = h.hsl[2] - 10;

  b < 30 && (b = h.hsl[2] + 50);
  var v = h.alpha,
      w = "hsl(".concat(h.hsl[0], ", ").concat(h.hsl[1], "%, ").concat(b, "%, ").concat(v, ")"),
      y = ie(M({
    width: t,
    minWidth: t,
    height: t,
    hoverColor: w,
    borderColor: n,
    borderWidth: o,
    alpha: v,
    colorError: !!h.error
  }, m)),
      k = r.createElement(f, P({
    "data-testid": "colorbutton",
    className: "".concat(y.root, " ").concat(null != s ? s : ""),
    ref: l,
    variant: "contained",
    "aria-label": h.name
  }, d), r.createElement("div", null));
  return i ? r.createElement(x, {
    title: g
  }, r.createElement("div", {
    className: y.tooltip
  }, k)) : k;
};

ce.propTypes = {
  color: ae.isRequired,
  size: n.number,
  disableAlpha: n.bool,
  borderWidth: n.number,
  borderColor: n.string,
  tooltip: n.string,
  forwardRef: n.shape({
    current: n.elementType
  })
}, ce.defaultProps = {
  size: 24,
  borderWidth: 0,
  borderColor: void 0,
  forwardRef: void 0,
  tooltip: void 0,
  disableAlpha: !1
};
var se = "undefined" != typeof window ? e.useLayoutEffect : e.useEffect;

function de(r) {
  var a = e.useRef(r);
  return se(function () {
    a.current = r;
  }), e.useCallback(function () {
    return (0, a.current).apply(void 0, arguments);
  }, []);
}

var ue = m({
  root: {
    position: "absolute",
    width: "inherit",
    height: "inherit",
    background: function background(e) {
      return "".concat(e.cssRgb, " none repeat scroll 0% 0%");
    },
    margin: 0
  },
  gradientPosition: {
    position: "absolute",
    width: "100%",
    height: "100%"
  },
  hsvGradientS: {
    background: "rgba(0, 0, 0, 0) linear-gradient(to right, rgb(255, 255, 255), rgba(255, 255, 255, 0)) repeat scroll 0% 0%"
  },
  hsvGradientV: {
    background: "rgba(0, 0, 0, 0) linear-gradient(to top, rgb(0, 0, 0), rgba(0, 0, 0, 0)) repeat scroll 0% 0%"
  },
  hslGradientS: {
    background: "rgba(0, 0, 0, 0) linear-gradient(to bottom, rgb(128, 128, 128), rgba(255, 255, 255, 0)) repeat scroll 0% 0%"
  },
  hslGradientL: {
    background: "rgba(0, 0, 0, 0) linear-gradient(to left, rgb(0, 0, 0), rgba(128, 128, 128, 0), rgb(255, 255, 255)) repeat scroll 0% 0%"
  },
  hsvGradientCursor: {
    position: "absolute",
    top: 0,
    left: 0,
    borderColor: "#f0f0f0",
    borderWidth: 1,
    borderStyle: "solid",
    boxShadow: "rgba(0, 0, 0, 0.37) 0px 1px 4px 0px",
    transition: "box-shadow 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    borderRadius: 4,
    cursor: function cursor(e) {
      return !e.pressed && "pointer";
    },
    zIndex: 100,
    transform: "translate(-4px, -4px)",
    "&:hover": {
      boxShadow: "0px 0px 0px 8px rgba(63, 81, 181, 0.16)"
    },
    "&:focus": {
      outline: "none !important",
      boxShadow: "0px 0px 0px 8px rgba(63, 81, 181, 0.16)"
    },
    "&:focus > div": {}
  },
  hsvGradientCursorC: {
    width: 8,
    height: 8,
    borderRadius: 4,
    boxShadow: "white 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08)"
  }
}),
    pe = function pe(e) {
  var a = e.className,
      t = e.color,
      o = e.onChange,
      n = e.isHsl,
      l = A(e, ["className", "color", "onChange", "isHsl"]),
      i = r.useRef(t),
      _r$useState = r.useState(!1),
      _r$useState2 = _slicedToArray(_r$useState, 2),
      c = _r$useState2[0],
      s = _r$useState2[1],
      d = r.useRef(!1);

  r.useEffect(function () {
    i.current = t;
  });

  var u,
      p,
      h,
      g,
      m,
      b,
      v,
      f = r.useRef(),
      x = r.useRef(),
      w = {
    x: 0,
    y: 0
  },
      y = (u = t.hsv[0], p = u / 360, h = 255, g = Math.floor(6 * p), m = 6 * p - g, b = Math.round(h * (1 - m)), v = Math.round(h * m), h = Math.round(h), 0 == (g %= 6) ? [h, v, 0] : 1 === g ? [b, h, 0] : 2 === g ? [0, h, v] : 3 === g ? [0, b, h] : 4 === g ? [v, 0, h] : [h, 0, b]),
      k = "rgb(".concat(y[0], ",").concat(y[1], ",").concat(y[2], ")"),
      C = ue(M(M({}, l), {}, {
    cssRgb: k
  })),
      E = function E(e, r) {
    w = e, x.current.style.top = "".concat(e.y, "px"), x.current.style.left = "".concat(e.x, "px"), r && x.current.focus();
  },
      N = function N(e) {
    if (e) {
      var r = t.hsv,
          a = t.hsl;
      w = {
        x: Math.round((n ? 100 - a[2] : r[1]) / 100 * (e.clientWidth - 1)),
        y: Math.round((n ? a[1] : 100 - r[2]) / 100 * (e.clientHeight - 1))
      }, E(w);
    }
  };

  N(f.current), f.current && (f.current.style.background = "".concat(k, " none repeat scroll 0% 0%"));

  var O = function O(e, r) {
    var a = e.x,
        t = e.y,
        l = r.getBoundingClientRect(),
        c = {
      x: a - l.left,
      y: t - l.top
    };
    c.x < 0 && (c.x = 0), c.y < 0 && (c.y = 0), c.x >= r.clientWidth && (c.x = r.clientWidth - 1), c.y >= r.clientHeight && (c.y = r.clientHeight - 1), E(c, !0);
    var s = i.current;

    if (n) {
      var d = c.y / (r.clientHeight - 1) * 100,
          u = 100 * (1 - c.x / (r.clientWidth - 1));
      o([s.hsl[0], d, u]);
    } else {
      var p = c.x / (r.clientWidth - 1) * 100,
          h = 100 * (1 - c.y / (r.clientHeight - 1));
      o([s.hsv[0], p, h]);
    }
  };

  r.useEffect(function () {
    var e = f.current;
    N(e);

    var r = function r(e) {
      s(!0), d.current = !0, e.preventDefault();
    },
        a = function a(r) {
      var a = {
        x: r.pageX - window.scrollX,
        y: r.pageY - window.scrollY
      };
      O(a, e), d.current = !1, r.preventDefault();
    },
        t = function t(r) {
      if (d.current && r.buttons) {
        var a = {
          x: r.pageX - window.scrollX,
          y: r.pageY - window.scrollY
        };
        O(a, e), r.preventDefault();
      }
    },
        o = function o(r) {
      var a = {
        x: r.touches[0].pageX - window.scrollX,
        y: r.touches[0].pageY - window.scrollY
      };
      O(a, e), r.preventDefault();
    };

    return e.addEventListener("mousedown", r), e.addEventListener("mouseup", a), e.addEventListener("mousemove", t), e.addEventListener("touchdown", r), e.addEventListener("touchup", a), e.addEventListener("touchmove", o), function () {
      e.removeEventListener("mousedown", r), e.removeEventListener("mouseup", a), e.removeEventListener("mousemove", t), e.removeEventListener("touchdown", r), e.removeEventListener("touchup", a), e.removeEventListener("touchmove", o);
    };
  }, []);
  var R = de(function (e) {
    if (c) {
      var _w = w,
          r = _w.x,
          a = _w.y;

      switch (e.key) {
        case "ArrowRight":
          r += 1;
          break;

        case "ArrowLeft":
          r -= 1;
          break;

        case "ArrowDown":
          a += 1;
          break;

        case "ArrowUp":
          a -= 1;
          break;

        case "Tab":
          return void s(!1);

        default:
          return;
      }

      e.preventDefault();
      var t = f.current.getBoundingClientRect();
      O({
        x: r + t.left,
        y: a + t.top
      }, f.current);
    }
  }),
      S = de(function (e) {
    s(!0), e.preventDefault();
  }),
      W = de(function (e) {
    s(!1), e.preventDefault();
  });
  return r.createElement("div", {
    className: a
  }, r.createElement("div", P({
    className: C.root
  }, l, {
    ref: f,
    "data-testid": "hsvgradient-color"
  }), r.createElement("div", {
    className: "muicc-hsvgradient-s ".concat(n ? C.hslGradientS : C.hsvGradientS, " ").concat(C.gradientPosition)
  }, r.createElement("div", {
    className: "muicc-hsvgradient-v ".concat(n ? C.hslGradientL : C.hsvGradientV, " ").concat(C.gradientPosition)
  }, r.createElement("div", {
    ref: x,
    tabIndex: "0",
    role: "slider",
    "aria-valuemax": 100,
    "aria-valuemin": 0,
    "aria-valuenow": t.hsv[1],
    pressed: "".concat(d.current),
    "data-testid": "hsvgradient-cursor",
    className: "muicc-hsvgradient-cursor ".concat(C.hsvGradientCursor),
    onKeyDown: R,
    onFocus: S,
    onBlur: W
  }, r.createElement("div", {
    className: "muicc-hsvgradient-cursor-c ".concat(C.hsvGradientCursorC)
  }))))));
};

pe.propTypes = {
  color: ae.isRequired,
  className: n.string.isRequired,
  onChange: n.func.isRequired,
  isHsl: n.bool
}, pe.defaultProps = {
  isHsl: !1
};

var he = function he(e) {
  var a = e.Element,
      t = e.defaultValue,
      o = A(e, ["Element", "defaultValue"]),
      _r$useState3 = r.useState(t),
      _r$useState4 = _slicedToArray(_r$useState3, 2),
      n = _r$useState4[0],
      l = _r$useState4[1];

  return r.createElement(a, M(M({}, o), {}, {
    value: n,
    onChange: l
  }));
},
    ge = function ge(e) {
  var a = function a(_a) {
    var t = _a.defaultValue,
        o = _a.value,
        n = _a.onChange,
        l = A(_a, ["defaultValue", "value", "onChange"]);
    return n || "none" !== o ? r.createElement(e, M({
      value: o || t,
      onChange: n || function () {}
    }, l)) : r.createElement(he, M({
      Element: e,
      defaultValue: t
    }, l));
  };

  return a.propTypes = M(M({}, e.propTypes), {}, {
    defaultValue: e.propTypes.value,
    onChange: n.func
  }), a.defaultProps = M(M({}, e.defaultProps), {}, {
    defaultValue: void 0,
    onChange: void 0
  }), a;
},
    me = m({
  root: {
    display: "flex",
    flexDirection: "row"
  },
  colorinputRaw: {
    paddingRight: 4
  },
  formControl: {
    width: 100
  }
}),
    be = function be(e) {
  var a,
      t,
      o = e.value,
      n = e.format,
      l = e.onChange,
      i = e.disableAlpha,
      c = e.enableErrorDisplay,
      s = e.forwardRef,
      d = e.disablePlainColor,
      u = A(e, ["value", "format", "onChange", "disableAlpha", "enableErrorDisplay", "forwardRef", "disablePlainColor"]),
      p = me(),
      _le2 = le(),
      h = _le2.t,
      g = _le2.i18n,
      m = re(o, i, h, g.language, d),
      b = function b(e) {
    if ("plain" === n) l(e.target.value);else if ("hex" === n) l("#".concat(e.target.value));else {
      var r = e.target.id,
          a = Number(e.target.value),
          o = {};
      Object.keys(t).forEach(function (e) {
        var n = t[e].value;
        e === r && ((n = a) < t[e].min && (n = t[e].min), n > t[e].max && (n = t[e].max)), o[e] = n;
      }), l(o);
    }
  },
      v = function v(e, a, t, o, n) {
    return r.createElement(r.Fragment, null, r.createElement(E, {
      htmlFor: e,
      className: "muicc-colorinput-label",
      "data-testid": "colorinput-label"
    }, a), r.createElement(N, P({
      id: e,
      name: e,
      className: "muicc-colorinput-input",
      label: a,
      value: t,
      placeholder: a,
      inputProps: {
        "aria-label": "color-".concat(a),
        "data-testid": "colorinput-input"
      },
      onChange: b,
      startAdornment: n && o && r.createElement(O, {
        position: "start"
      }, o)
    }, u)));
  };

  if ("plain" === n) a = v("color-plain", "Color", m.raw);else {
    t = function (e, r, a) {
      var t = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : function (e) {
        return e;
      },
          o = re(e, a, t),
          n = {};
      if ("rgb" === r) n.r = {
        value: o.rgb[0],
        format: "integer",
        min: 0,
        max: 255,
        name: t("R")
      }, n.g = {
        value: o.rgb[1],
        format: "integer",
        min: 0,
        max: 255,
        name: t("G")
      }, n.b = {
        value: o.rgb[2],
        format: "integer",
        min: 0,
        max: 255,
        name: t("B")
      };else if ("hsv" === r) n.h = {
        value: o.hsv[0],
        format: "integer",
        min: 0,
        max: 360,
        name: t("H"),
        unit: "°"
      }, n.s = {
        value: o.hsv[1],
        format: "integer",
        min: 0,
        max: 100,
        name: t("S"),
        unit: "%"
      }, n.v = {
        value: o.hsv[2],
        format: "integer",
        min: 0,
        max: 100,
        name: t("V"),
        unit: "%"
      };else if ("hsl" === r) n.h = {
        value: o.hsl[0],
        format: "integer",
        min: 0,
        max: 360,
        name: t("H"),
        unit: "°"
      }, n.s = {
        value: o.hsl[1],
        format: "integer",
        min: 0,
        max: 100,
        name: t("S"),
        unit: "%"
      }, n.l = {
        value: o.hsl[2],
        format: "integer",
        min: 0,
        max: 100,
        name: t("L"),
        unit: "%"
      };else if ("hex" === r) {
        var l = o.hex;
        o.raw && "string" == typeof o.raw && o.raw.startsWith("#") && (l = o.raw.substring(1)), n.hex = {
          value: l,
          format: "hex",
          name: t("HEX"),
          unit: "#"
        };
      } else n.value = t(o.value), n.format = "unknown";
      return n;
    }(m, n, i, h);

    var f = Object.keys(t);
    a = r.createElement("div", {
      ref: s,
      className: p.root
    }, f.map(function (e) {
      return r.createElement(k, {
        key: e,
        className: "muicc-colorinput-raw ".concat(p.colorinputRaw),
        error: !!m.error
      }, v(e, t[e].name, t[e].value, t[e].unit, 1 === f.length));
    }));
  }
  return r.createElement(k, {
    className: p.formControl,
    error: !!m.error,
    "data-testid": "colorinput"
  }, a, c && m.error && r.createElement(C, {
    id: "component-error-text"
  }, m.error));
};

be.propTypes = {
  value: ae,
  format: n.string,
  onChange: n.func.isRequired,
  disableAlpha: n.bool,
  enableErrorDisplay: n.bool,
  forwardRef: n.shape({
    current: n.elementType
  }),
  disablePlainColor: n.bool
}, be.defaultProps = {
  value: "none",
  format: "plain",
  forwardRef: void 0,
  disableAlpha: !1,
  enableErrorDisplay: !0,
  disablePlainColor: !1
};

var ve = ge(be),
    fe = m({
  root: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    padding: "8px 0 0 8px"
  },
  paletteButton: {
    margin: "0 8px 8px 0",
    padding: 0
  }
}),
    xe = function xe(e) {
  var a = e.size,
      t = e.borderWidth,
      o = e.palette,
      n = e.onSelect,
      l = e.disableAlpha,
      i = fe(),
      _le3 = le(),
      c = _le3.t;

  return r.createElement("div", {
    className: i.root
  }, Object.keys(o).map(function (e) {
    return r.createElement(ce, {
      size: a,
      key: "".concat(e),
      color: o[e],
      className: "muicc-palette-button ".concat(i.paletteButton),
      borderWidth: t,
      tooltip: e,
      disableAlpha: l,
      onClick: function onClick() {
        return function (e) {
          var r = c(e);
          n && n(r, o[e]);
        }(e);
      }
    });
  }));
};

xe.propTypes = {
  borderWidth: n.number,
  size: n.number,
  palette: te.isRequired,
  forwardRef: n.shape({
    current: n.elementType
  }),
  onSelect: n.func,
  disableAlpha: n.bool
}, xe.defaultProps = {
  borderWidth: 0,
  size: 24,
  forwardRef: void 0,
  onSelect: void 0,
  disableAlpha: !1
};
var we = m(function () {
  return {
    root: {
      width: "100%",
      height: 16,
      padding: 0
    },
    rail: {
      height: 16,
      opacity: 1,
      background: "rgba(0, 0, 0, 0) linear-gradient(to right, rgb(255, 0, 0) 0%, rgb(255, 255, 0) 17%, rgb(0, 255, 0) 33%, rgb(0, 255, 255) 50%, rgb(0, 0, 255) 67%, rgb(255, 0, 255) 83%, rgb(255, 0, 0) 100% ) repeat scroll 0% 0%",
      borderRadius: 0
    },
    track: {
      height: 16,
      opacity: 0,
      borderRadius: 4,
      backgroundColor: "transparent"
    },
    thumb: {
      width: 16,
      height: 16,
      marginTop: 0,
      marginLeft: -8,
      backgroundColor: "#f0f0f0",
      boxShadow: "rgba(0, 0, 0, 0.37) 0px 1px 4px 0px",
      "&:focus": {
        boxShadow: "0px 0px 0px 8px rgba(63, 81, 181, 0.16)"
      }
    }
  };
});

function ye(e) {
  var a = we();
  return r.createElement(R, P({}, e, {
    classes: {
      root: a.root,
      rail: a.rail,
      track: a.track,
      thumb: a.thumb
    }
  }));
}

var ke = m({
  root: {
    color: "#666",
    width: "100%",
    height: 16,
    padding: 0,
    background: "linear-gradient(45deg, #ccc 25%, transparent 25%), linear-gradient(135deg, #ccc 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #ccc 75%), linear-gradient(135deg, transparent 75%, #ccc 75%)",
    backgroundSize: "8px 8px",
    backgroundColor: "white",
    backgroundPosition: "0 0, 4px 0, 4px -4px, 0px 4px"
  },
  rail: {
    height: 16,
    opacity: 1,
    background: function background(e) {
      return "rgba(0, 0, 0, 0) linear-gradient(to right, ".concat(e.color, "00 0%, ").concat(e.color, " 100%) repeat scroll 0% 0%");
    },
    borderRadius: 0
  },
  track: {
    height: 16,
    opacity: 0,
    borderRadius: 4
  },
  thumb: {
    width: 16,
    height: 16,
    marginTop: 0,
    marginLeft: -8,
    backgroundColor: "#f0f0f0",
    boxShadow: "rgba(0, 0, 0, 0.37) 0px 1px 4px 0px",
    "&:focus": {
      boxShadow: "0px 0px 0px 8px rgba(63, 81, 181, 0.16)"
    }
  }
});

function Ce(e) {
  var a = e.color,
      t = A(e, ["color"]),
      o = ke({
    color: a
  });
  return r.createElement(R, P({}, t, {
    classes: {
      root: o.root,
      rail: o.rail,
      track: o.track,
      thumb: o.thumb
    }
  }));
}

Ce.propTypes = {
  color: ae.isRequired
};

var Ee = m(function (e) {
  return {
    root: {
      backgroundColor: e.palette.background.paper,
      position: "relative",
      width: "min-content",
      height: "min-content",
      padding: "0px"
    },
    container: {
      justifyContent: "space-around",
      overflow: "hidden",
      width: function width(e) {
        return e.boxWidth;
      },
      padding: 0
    },
    colorboxHsvGradient: {
      width: function width(e) {
        return "calc(".concat(e.boxWidth, "px - 16px)");
      },
      height: "calc(128px - 16px)",
      margin: 8
    },
    colorboxSliders: {
      width: function width(e) {
        return e.boxWidth;
      },
      padding: "8px 8px 4px 8px"
    },
    colorboxInputs: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      padding: "8px 4px 8px 8px",
      justifyContent: "space-between"
    },
    colorboxInput: {},
    colorboxColorBg: {
      width: 48,
      height: 48,
      background: "linear-gradient(45deg, #ccc 25%, transparent 25%), linear-gradient(135deg, #ccc 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #ccc 75%), linear-gradient(135deg, transparent 75%, #ccc 75%)",
      backgroundSize: "8px 8px",
      backgroundPosition: "0 0, 4px 0, 4px -4px, 0px 4px",
      backgroundColor: "white",
      borderRadius: 4
    },
    colorboxColor: {
      width: 48,
      height: 48,
      background: function background(e) {
        return e.colorError ? "repeating-linear-gradient(\n      135deg,\n      transparent,\n      transparent 29px,\n      #f44336 29px,\n      #f44336 32px\n    )" : "none";
      },
      backgroundColor: function backgroundColor(e) {
        return e.colorError ? "transparent" : e.backgroundColor;
      },
      borderRadius: 4,
      border: function border(e) {
        return e.colorError ? "2px solid #f44336" : "none";
      }
    },
    colorboxControls: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      padding: 8,
      "&> button": {
        marginLeft: "auto"
      }
    },
    colorboxError: {
      color: "#f44336",
      lineHeight: "36.5px"
    }
  };
}),
    Ne = function Ne(e) {
  var _r$useState5, _r$useState6;

  var a,
      t = e.value,
      o = e.palette,
      n = e.inputFormats,
      l = e.deferred,
      i = e.onChange,
      c = e.disableAlpha,
      s = e.hslGradient,
      d = A(e, ["value", "palette", "inputFormats", "deferred", "onChange", "disableAlpha", "hslGradient"]),
      _le4 = le(),
      u = _le4.t,
      p = _le4.i18n,
      h = re(t, c, u, p.language),
      g = i;

  l && ((_r$useState5 = r.useState(h), _r$useState6 = _slicedToArray(_r$useState5, 2), h = _r$useState6[0], g = _r$useState6[1], _r$useState5), a = i);
  var _h = h,
      m = _h.hsv,
      b = _h.hsl,
      _h2 = h,
      v = _h2.alpha;
  v = void 0 === v ? 100 : Math.floor(100 * v);

  var x = ee(h, "hex", !0),
      k = h.css.backgroundColor,
      C = Ee({
    boxWidth: 320,
    backgroundColor: k,
    colorError: !!h.error
  }),
      E = function E(e) {
    var r = _(e);

    g(r);
  };

  return r.createElement(w, P({
    p: 2,
    className: C.root
  }, d), r.createElement(w, {
    className: C.container
  }, r.createElement(pe, {
    className: "muicc-colorbox-hsvgradient ".concat(C.colorboxHsvGradient),
    color: h,
    onChange: function onChange(e) {
      var r = _(e, s ? "hsl" : "hsv");

      g(r);
    },
    isHsl: s
  }), r.createElement("div", {
    className: "muicc-colorbox-sliders ".concat(C.colorboxSliders)
  }, r.createElement(ye, {
    "data-testid": "hueslider",
    "aria-label": "color slider",
    value: s ? b[0] : m[0],
    min: 0,
    max: 360,
    onChange: function onChange(e, r) {
      var a = _([r, h.hsv[1], h.hsv[2]], "hsv");

      g(a);
    }
  }), !c && r.createElement(Ce, {
    "data-testid": "alphaslider",
    color: x,
    valueLabelDisplay: "auto",
    "aria-label": "alpha slider",
    value: v,
    min: 0,
    max: 100,
    onChange: function onChange(e, r) {
      var a = r / 100,
          t = _([h.rgb[0], h.rgb[1], h.rgb[2], a], "rgb");

      g(t);
    }
  })), n.length > 0 && r.createElement("div", {
    className: "muicc-colorbox-inputs  ".concat(C.colorboxInputs)
  }, r.createElement("div", {
    className: "muicc-colorbox-colorBg ".concat(C.colorboxColorBg)
  }, r.createElement("div", {
    className: "muicc-colorbox-color ".concat(C.colorboxColor)
  })), n.map(function (e) {
    return r.createElement(ve, {
      key: e,
      value: h,
      format: e,
      disableAlpha: !0,
      enableErrorDisplay: !1,
      className: "muicc-colorbox-input ".concat(C.colorboxInput),
      onChange: E
    });
  })), o && r.createElement(r.Fragment, null, r.createElement(y, null), r.createElement(xe, {
    size: 26.65,
    palette: o,
    onSelect: function onSelect(e, r) {
      var a = _(r);

      a.name = e, g(a);
    },
    disableAlpha: c
  })), r.createElement("div", {
    className: "muicc-colorbox-controls ".concat(C.colorboxControls)
  }, h.error && r.createElement("span", {
    className: "muicc-colorbox-error ".concat(C.colorboxError),
    "data-testid": "colorbox-error"
  }, u(h.error)), l && r.createElement(f, {
    onClick: function onClick() {
      a(h);
    }
  }, u("Set")))));
};

Ne.propTypes = {
  value: ae,
  deferred: n.bool,
  palette: te,
  inputFormats: oe,
  onChange: n.func.isRequired,
  disableAlpha: n.bool,
  hslGradient: n.bool
}, Ne.defaultProps = {
  value: void 0,
  deferred: !1,
  palette: void 0,
  inputFormats: ["hex", "rgb"],
  disableAlpha: !1,
  hslGradient: !1
};

var Oe = ge(Ne),
    Re = m({
  root: {
    display: "flex",
    flexDirection: "row",
    width: "max-content"
  },
  colorpickerButton: {
    margin: 6
  }
}),
    Se = b({
  seed: "ColorPicker"
}),
    Pe = function Pe(e) {
  var n = e.value,
      l = e.disableTextfield,
      i = e.deferred,
      c = e.palette,
      s = e.inputFormats,
      d = e.openAtStart,
      u = e.onChange,
      p = e.onOpen,
      m = e.doPopup,
      b = e.disableAlpha,
      f = e.hslGradient,
      x = e.hideTextfield,
      w = e.disablePlainColor,
      y = Re(),
      k = a(null),
      _t = t(!1),
      _t2 = _slicedToArray(_t, 2),
      C = _t2[0],
      E = _t2[1],
      _le5 = le(),
      N = _le5.t,
      O = _le5.i18n,
      R = re(n, b, N, O.language, w),
      S = function (e, r) {
    var a = r ? "color-".concat(e.hex) : e.name;
    return a.startsWith("color-") ? a = "string" == typeof e.raw && e.raw.startsWith("#") ? e.raw : ee(e, "hex") : "none" === a && (a = e.raw), a;
  }(R, w);

  o(function () {
    d && E(!0);
  }, [d]);

  var P = function P() {
    var e = Boolean(k.current);
    E(e), p && p(e);
  },
      W = function W() {
    E(!1), p && p(!1);
  },
      M = r.createElement(Oe, {
    value: R,
    style: {
      position: "relative"
    },
    deferred: i,
    palette: c,
    inputFormats: s,
    disableAlpha: b,
    hslGradient: f,
    onChange: function onChange(e) {
      u(e), i && W();
    }
  });

  M = m ? m(M) : r.createElement(g, {
    id: "color-popover",
    open: C,
    anchorEl: k.current,
    onClose: W,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "center"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "center"
    }
  }, M);
  var A = null;
  return x || (A = l ? r.createElement("div", {
    role: "button",
    "data-testid": "colorpicker-noinput",
    onClick: P
  }, R.raw) : r.createElement(h, {
    color: "primary",
    value: S,
    onChange: function onChange(e) {
      u(e.target.value);
    },
    "data-testid": "colorpicker-input"
  })), r.createElement(v, {
    generateClassName: Se
  }, r.createElement("div", {
    ref: k,
    className: y.root
  }, r.createElement(ce, {
    "data-testid": "colorpicker-button",
    className: "muicc-colorpicker-button ".concat(y.colorpickerButton),
    color: R,
    onClick: P
  }), A, M));
};

Pe.propTypes = {
  value: ae,
  disableTextfield: n.bool,
  deferred: n.bool,
  palette: te,
  inputFormats: oe,
  onChange: n.func.isRequired,
  onOpen: n.func,
  openAtStart: n.bool,
  doPopup: n.func,
  disableAlpha: n.bool,
  hslGradient: n.bool,
  hideTextfield: n.bool,
  disablePlainColor: n.bool
}, Pe.defaultProps = {
  value: "none",
  disableTextfield: !1,
  deferred: !1,
  palette: void 0,
  inputFormats: ["hex", "rgb"],
  onOpen: void 0,
  openAtStart: !1,
  doPopup: void 0,
  disableAlpha: !1,
  hslGradient: !1,
  hideTextfield: !1,
  disablePlainColor: !1
};
var We = ge(Pe);
export { Oe as ColorBox, ce as ColorButton, ve as ColorInput, xe as ColorPalette, We as ColorPicker, _ as createColor, le as useTranslate };